import colors from '@/config/colors';
import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  licenseBanner: {
    flexDirection: 'row',
    gap: 8,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 10,
    backgroundColor: colors.yellow,
  },
  alertTriangle: {
    position: 'absolute',
    top: -8,
    left: -8,
    color: colors.yellow,
  },
});
